import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';

//#region INTERFACE IFeatureDashboard
export interface IFeatureDashboard extends IUserAccessFeature, Object {
}

//#endregion

//#region CONST _FEATURE_DASHBOARD_DEFAULT
export const _FEATURE_DASHBOARD_DEFAULT: Readonly<IFeatureDashboard & Object> = {
  displayText: NavigationPageEnumHumanReadable.Dashboard,
  feature: NavigationPageEnum.Dashboard,
  ref: SettingsReferenceEnum.undefined,
  standalone: false,
};
//#endregion